import { db } from "../firebase/config";
import { collection, doc, addDoc, updateDoc, deleteDoc, onSnapshot } from "firebase/firestore";

export function subscribeToBuildings(callback) {
  return onSnapshot(collection(db, "buildings"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    // Sort by name if name exists
    list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to buildings:", error);
    callback([], error);
  });
}

export async function seedDefaultBuildingIfEmpty(buildings) {
  if (buildings.length > 0) return null;
  const docRef = await addDoc(collection(db, "buildings"), { name: "Main Warehouse" });
  return docRef.id;
}

export async function addBuilding(buildingData) {
  const docRef = await addDoc(collection(db, "buildings"), buildingData);
  return docRef.id;
}

export async function updateBuilding(id, buildingData) {
  const docRef = doc(db, "buildings", id);
  await updateDoc(docRef, buildingData);
}

export async function deleteBuilding(id) {
  const docRef = doc(db, "buildings", id);
  await deleteDoc(docRef);
}
